namespace Ir.Components.Workbook.Settings.Items.FormattingRuleSetting {
    export interface IFormattingRuleSettingParams {
        label?: string;
        id: KnockoutObservable<number>;
        onSelected?(newValue: FormattingRule, oldValue: FormattingRule);
        onClear?(oldValue: FormattingRule);
    }
    interface IViewModel {
        textBoxOptions: DevExpress.ui.dxTextBox.Properties;
        popoverButtonOptions: DevExpress.ui.dxButton.Properties;
        removeButtonOptions: DevExpress.ui.dxButton.Properties;
        label: string;
    }

    interface IParams {
        config: IFormattingRuleSettingParams;
    }
    
    export function getViewModel(this: IViewModel, params: IParams) {
        let self = this;
        self.label = params.config.label ?? "Formatting Rule";

        let formattingRule = ko.computed(function (this: KnockoutObservable<number>) {
            let id = this();
            let formattingRule: FormattingRule = null;
            if (id !== 0) {
                formattingRule = FormattingRuleService.getFormattingRuleById(id);
            }
            return formattingRule;
        }, params.config.id);

        let name = ko.computed(function (this: KnockoutObservable<number>) {
            let formattingRuleValue = formattingRule();
            let nameValue = "";
            if (formattingRuleValue) {
                nameValue = formattingRuleValue.displayName();
            }
            return nameValue;
        });

        let $textbox;

        self.textBoxOptions = {
            value: name as any,
            width: "100%",
            readOnly: true,
            onInitialized(e) {
                $textbox = e.element;
            }
        };

        self.popoverButtonOptions = {
            icon: "ms ir-find-icon",
            hint: "Choose the " + params.config.label,
            onClick: function (e) {
                let onSelected = function (item: FormattingRule) {
                    if (params.config.onSelected) {
                        params.config.onSelected(item, formattingRule());
                    }
                    params.config.id(item.id);
                };

                FormattingRuleService.show($textbox, onSelected);
            }
        };

        self.removeButtonOptions = {
            icon: "ms ir-clear-icon",
            hint: "Remove the " + params.config.label,
            onClick: function (e) {
                if (params.config.onClear) {
                    params.config.onClear(formattingRule());
                }
                params.config.id(null);
            }
        };
    }
}